import styled from "styled-components";
import { breakpoints } from "../../../../constants/breakpoints";

export const ContainerHeader = styled.div`
  flex-direction: row;
  column-gap: 40px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 100%;
  width: 100%;
  padding: 0;

  ${breakpoints.tabletL} {
    align-items: center;
    row-gap: 40px;
  }

  ${breakpoints.tabletM} {
    flex-direction: column;
    justify-content: center;
  }

  ${breakpoints.phoneL} {
    row-gap: 24px;
  }
`;

export const ContainerMainTitle = styled.div`
  position: relative;
  padding: 0 0 40px;
  width: 100%;

  ${breakpoints.tabletM} {
    width: fit-content;
  }
`;

export const RectImg = styled.div`
  position: absolute;
  background: #c6e7ec;
  width: 60px;
  height: 60px;
  border-radius: 10px;
  transform: rotate(50deg);
  z-index: 0;
`;

export const ContainerText = styled.div`
  position: relative;
  top: 0px;
  left: 15px;
  width: 100%;

  > span {
    font-weight: bold;
    font-size: 3.8rem;
  }
  > span:nth-child(1) {
    color: #b92164;
  }
  > span:nth-child(2) {
    color: #a27dea;
  }

  ${breakpoints.tabletL} {
    top: 10px;

    > span {
      font-size: 2.8rem;
    }
  }
  ${breakpoints.tabletM} {
    > span {
      font-size: 2.8rem;
    }
  }
  ${breakpoints.phoneL} {
    > span {
      font-size: 2.2rem;
    }
  }
`;

export const ContainerDescription = styled.div`
  width: 100%;
  padding: 30px 0 10px;

  > p {
    font-size: 1.2rem;
    line-height: 1.2;
    letter-spacing: normal;
  }

  ${breakpoints.tabletL} {
    text-align: justify;
    padding: 20px 10px 0;
  }

  ${breakpoints.tabletM} {
    padding: 10px 10px 0;
  }

  ${breakpoints.phoneL} {
    padding: 20px 20px 20px;
  }
`;

export const ContainerButton = styled.div`
  width: 100%;
  margin-top: 50px;

  > div {
    border: double 1px transparent;
    border-radius: 5px;
    background-image: linear-gradient(white, white),
      linear-gradient(
        90deg,
        rgba(238, 102, 77, 1) 0%,
        rgba(212, 69, 233, 1) 100%
      );
    background-origin: border-box;
    background-clip: padding-box, border-box;
    width: fit-content;
    padding: 2px;

    > a {
      text-decoration: none;
      background: linear-gradient(
        90deg,
        rgba(238, 102, 77, 1) 0%,
        rgba(212, 69, 233, 1) 100%
      );
      outline: none;
      color: white;
      border: 0;
      padding: 5px 15px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 5px;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;

      > svg {
        max-width: 30px;
        width: 100%;
      }
    }

    ${breakpoints.tabletM} {
      margin: auto;
    }
  }
`;

export const ContainerHeaderLeft = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: left;

  ${breakpoints.tabletM} {
    justify-content: center;
  }
`;

export const ContainerHeaderRight = styled.div`
  box-sizing: border-box;
  height: 100%;
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: right;

  ${breakpoints.tabletL} {
    justify-content: center;
  }
  ${breakpoints.tabletM} {
    width: 100%;
  }
`;

export const ContainerRight = styled.div`
  width: 350px;
  height: 350px;
  background: #bed9c5;
  border-radius: 50%;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  ${breakpoints.phoneL} {
    width: 280px;
    height: 280px;
  }
`;
